import React, { useState } from 'react';
import { AnimatePresence, motion, useReducedMotion } from 'framer-motion';
import { applicationContexts } from '../../data/content';
export function Applications() {
  const [active, setActive] = useState(0);
  const reduceMotion = useReducedMotion();
  const current = applicationContexts[active];
  const CurrentIcon = current.icon;
  return <section className="bg-white py-12 lg:py-20" aria-labelledby="applications-title" data-id="element-171" data-mp="14alu89ih7uem">
      <div className="mx-auto max-w-4xl px-5" data-id="element-172" data-mp="gkrixwdt2dwh">
        <div className="mx-auto max-w-3xl text-center" data-id="element-173" data-mp="bok9htm7ak9s">
          <h2 id="applications-title" className="font-display text-[26px] font-extrabold leading-tight tracking-tight text-ink sm:text-4xl" data-id="element-174" data-mp="blof2f9kadq3">
            ¿Dónde podés aplicar <span className="text-brand-600" data-id="element-175" data-mp="knnu5210n7qe">estas herramientas?</span>
          </h2>
          <p className="mt-2 font-display text-[15px] font-bold text-ink sm:text-lg" data-id="element-176" data-mp="3t3he5quk31c7">Una misma preparación. Distintos contextos de aplicación.</p>
          <p className="mt-3 text-sm leading-relaxed text-ink-soft sm:text-base" data-id="element-177" data-mp="3p0kya7wehjby">
            Las herramientas de REACTIVA TU CUERPO™ pueden ayudarte a desarrollar propuestas de actividad física orientadas a adultos mayores en diferentes contextos, de acuerdo con tu formación, perfil profesional y los requisitos de cada institución.
          </p>
        </div>

        <p className="mt-6 text-center text-xs font-semibold text-ink-soft lg:mt-8" data-id="element-178" data-mp="1qk1n6x0l18q8">Tocá cada espacio para ver cómo aplicarlo</p>

        <div role="tablist" aria-label="Espacios de aplicación" className="mt-3 flex flex-wrap justify-center gap-1.5 sm:gap-2" data-id="element-179" data-mp="szp6996xpmln">
          {applicationContexts.map((c, i) => {
          const Icon = c.icon;
          const selected = i === active;
          return <button key={c.title} type="button" role="tab" id={`app-tab-${i}`} aria-selected={selected} aria-controls="app-panel" onClick={() => setActive(i)} className={`flex items-center gap-1.5 rounded-full px-3 py-2 text-[13px] font-semibold leading-tight transition-[background-color,color,transform] duration-150 ease-out active:scale-[0.97] focus:outline-none focus-visible:ring-4 focus-visible:ring-brand-600/30 sm:text-sm ${selected ? 'bg-brand-600 text-white' : 'bg-brand-50 text-ink hover:bg-brand-100'}`} data-id="element-180" data-mp="17wg7zp42zaef" data-mpi={i}>
                <Icon className={`h-4 w-4 shrink-0 ${selected ? 'text-white' : 'text-brand-600'}`} aria-hidden="true" data-id="element-181" data-mp="hsz932wi0f6" />
                {c.title}
              </button>;
        })}
        </div>

        <div id="app-panel" role="tabpanel" aria-labelledby={`app-tab-${active}`} aria-live="polite" className="mx-auto mt-4 max-w-2xl overflow-hidden rounded-2xl bg-brand-950 text-white" data-id="element-182" data-mp="9b63h16f0ogk">
          <AnimatePresence mode="wait" initial={false} data-id="element-183" data-mp="38xcrpzvqzet6">
            <motion.div key={active} initial={reduceMotion ? false : {
            opacity: 0,
            y: 6
          }} animate={{
            opacity: 1,
            y: 0
          }} exit={reduceMotion ? {
            opacity: 0
          } : {
            opacity: 0,
            y: -6
          }} transition={{
            duration: 0.18,
            ease: [0.23, 1, 0.32, 1]
          }} className="flex items-start gap-3 p-4 sm:items-center sm:p-5" data-id="element-184" data-mp="38wulqbja9m82">
              <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-xl bg-sun text-ink" data-id="element-185" data-mp="2trytotx9d3nv">
                <CurrentIcon className="h-5 w-5" aria-hidden="true" data-id="element-186" data-mp="3hht6xclhou8n" />
              </span>
              <div className="min-w-0" data-id="element-187" data-mp="3mgnwcxdyph1q">
                <h3 className="font-display text-base font-extrabold leading-tight sm:text-lg" data-id="element-188" data-mp="37lzl12lvroe7">{current.title}</h3>
                <p className="mt-0.5 text-[13px] leading-snug text-brand-100 sm:text-sm" data-id="element-189" data-mp="3cjj9swg7fjke">{current.description}</p>
              </div>
            </motion.div>
          </AnimatePresence>
        </div>

        <p className="mx-auto mt-8 max-w-2xl text-center font-display text-lg font-extrabold uppercase leading-snug tracking-tight text-brand-950 sm:text-2xl" data-id="element-190" data-mp="216gs1y2dcnyn">
          Preparate para ampliar los espacios donde podés <span className="text-brand-600" data-id="element-191" data-mp="2cl1ymaq4hh7t">aplicar tus herramientas.</span>
        </p>
      </div>
    </section>;
}